import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import ContactOption from './ContactOption'
import messages from './messages'
import Collapsible from 'react-collapsible'
import _ from 'lodash'
import { isMobile } from 'react-device-detect';

const buildOptions = options =>
  _.chain(options)
    .filter({ presales: 0 })
    .reject(o =>
      isMobile
        ? _.includes(_.toLower(o.button_text), 'email')
        : _.includes(_.toLower(o.button_text), 'phone')
    )
    .value()

const ContactList = ({
  showAll,
  help,
  language,
  contactOptions,
  preSaleFlag,
  contactConfig,
  showFootprintForm,
  createUserEvent,
  resetAndClose
}) => {
  const translated = messages[language]

  const options =
    preSaleFlag || showAll ? contactOptions : buildOptions(contactOptions)

  const salesOptions =
    !preSaleFlag &&
    _.filter(
      contactOptions,
      o => o.presales === 1 && o.link_location !== 'support'
    )

  return (
    <div>
      {help ? (
        <p>{translated['help']}</p>
      ) : (
        <p>{contactConfig || translated['more']}</p>
      )}

      <p>{translated['reachout']}</p>
      <div>
        <h3>{translated['reveal']}</h3>
        {options.map((option, index) => (
          <ContactOption
            option={option}
            key={index}
            showFootprintForm={showFootprintForm}
            createUserEvent={createUserEvent}
            resetAndClose={resetAndClose}
          />
        ))}
        {!_.isEmpty(salesOptions) && (
          <Fragment>
            <Collapsible
              classParentString="CollapsibleContacts"
              trigger={translated['sales']}
            >
              {salesOptions.map((sales, index) => (
                <ContactOption
                  option={sales}
                  key={index}
                  showFootprintForm={showFootprintForm}
                  createUserEvent={createUserEvent}
                  resetAndClose={resetAndClose}
                />
              ))}
            </Collapsible>
          </Fragment>
        )}
      </div>
    </div>
  )
}

ContactList.propTypes = {
  help: PropTypes.bool,
  language: PropTypes.string,
  contactOptions: PropTypes.array.isRequired,
  preSaleFlag: PropTypes.bool,
  contactConfig: PropTypes.string,
  showFootprintForm: PropTypes.func,
  createUserEvent: PropTypes.func,
  resetAndClose: PropTypes.func
}

export default LanguageProvider(ContactList)



// WEBPACK FOOTER //
// ./src/components/ContactUsModal/ContactList.js